/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { Fragment } from 'react';

import { Colors, Link } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

const styles = {
  buttonLink: css`
    background: none !important;
    border: none;
    color: ${Colors.ocean};
    padding: 0 !important;
    cursor: pointer;
  `,
};

const views = {
  ['DEFAULT']: () => ({
    bodyText: (
      <Fragment>
        To turn on your Zap, you'll need access to{' '}
        <Link href="/apps/categories/premium" target="_blank">
          premium apps
        </Link>
        . Edit your Zap or upgrade now to turn on your Zap.
      </Fragment>
    ),
    type: 'DEFAULT',
    upgradeButtonText: 'Upgrade to Starter',
  }),

  ['DEFAULT_TRIAL_EXTENSION']: ({
    onUpgradeClick,
  }: {
    onUpgradeClick: () => void;
  }) => ({
    bodyText: (
      <Fragment>
        To turn on your Zap, you'll need access to{' '}
        <Link href="/apps/categories/premium" target="_blank">
          premium apps
        </Link>
        . <strong>Upgrade now</strong> or{' '}
        <strong>
          start a free 7-day trial of the{' '}
          <button css={styles.buttonLink} onClick={onUpgradeClick}>
            Professional plan
          </button>
        </strong>{' '}
        to use unlimited premium apps.
      </Fragment>
    ),
    type: 'DEFAULT_TRIAL_EXTENSION',
    upgradeButtonText: 'Upgrade to Starter',
  }),
};

type Props = {
  canExtendTrial: boolean;
  onUpgradeClick: () => void;
};

export const getActiveView = ({ canExtendTrial, onUpgradeClick }: Props) =>
  canExtendTrial
    ? views.DEFAULT_TRIAL_EXTENSION({
        onUpgradeClick,
      })
    : views.DEFAULT();
